export default __webpack_public_path__ + "static/media/kitchen.f2ca8a29.svg";